import { styled } from 'styled-components';

import { styledReset } from '@pkg/primitives';
export const InputWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    background: #151425;
    border-radius: 50px;
    height: 50px;
    line-height: 50px;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
`;

export const Input = styled.input`
    ${styledReset.input};
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    display: flex;

    color: ${(props) => props.theme.shades.white['80']};

    &::placeholder {
        color: ${(props) => props.theme.shades.white['40']};
    }
`;

export const InputContent = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 1px;
`;
export const InputIcon = styled.div`
    display: flex;
    color: ${(props) => props.theme.colors.greenDark};
`;
export const InputLabel = styled.label`
    display: flex;
    color: ${(props) => props.theme.shades.white['50']};
`;
